import { useEffect } from 'react'
import { useHelp } from './HelpProvider'

export const useHighlightStep = (stepIndex: number, ref: React.RefObject<HTMLElement>) => {
  const { currentStep, setAnchorEl } = useHelp()

  useEffect(() => {
    const el = ref.current
    if (!el) return

    if (currentStep === stepIndex) {
      el.classList.add('highlight-step')
      setAnchorEl(el) // 🛠 Anchor popover to this element
    } else {
      el.classList.remove('highlight-step')
    }
  }, [currentStep, stepIndex, ref])
}
